import {getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {to, separator, children, className} = self.get();

    return h('div', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this)
    }, [
        function() {try {return (to )} catch(e) {_e(e)}}.call($this) ?
            h('a', {
                'ev-click': function() {try {return (self.onClick )} catch(e) {_e(e)}}.call($this)
            }, function() {try {return (children )} catch(e) {_e(e)}}.call($this), 'k-item-link') :
            h('span', null, function() {try {return (children )} catch(e) {_e(e)}}.call($this), 'k-item-link'),
        function() {try {return (separator != null )} catch(e) {_e(e)}}.call($this) ?
            h('span', null, (_blocks['separator'] = function(parent) {
                return function() {try {return (separator )} catch(e) {_e(e)}}.call($this);
            }) && (__blocks['separator'] = function(parent) {
                var args = arguments;
                return blocks['separator'] ? blocks['separator'].apply($this, [function() {
                    return _blocks['separator'].apply($this, args);
                }].concat(__slice.call(args, 1))) : _blocks['separator'].apply($this, args);
            }) && __blocks['separator'].apply($this, [__noop]), 'k-separator') :
            undefined
    ], _className(function() {try {return ({"k-item": true, [className]: className} )} catch(e) {_e(e)}}.call($this)))
}